<template>
  <div class="google-login-wrapper">
    <!-- Google button (must be rendered) -->
    <div id="google-btn"></div>

    <!-- Your custom-styled button on top (click will bubble to Google button) -->
    <div class="custom-overlay-button">
      <button class="login-m-btn">
        <GoogleLogo />
        <span>Google</span>
      </button>
    </div>
  </div>
</template>


<script>
import constants from '../../../../../constant';
import GoogleLogo from '@/decast/icons/GoogleLogo.vue';

export default {
  name: "GoogleLogin",
  components: {
    GoogleLogo,
  },
  mounted() {
    if (window.google) {
      google.accounts.id.initialize({
        client_id: constants.googleLoginKey,
        callback: this.handleCredentialResponse,
        auto_select: false,
        ux_mode: 'popup',
      });

      // Render the real button
      google.accounts.id.renderButton(
        document.getElementById('google-btn'),
        {
          theme: 'outline',
          size: 'large',
          type: 'icon',
          width: 80
        }
      );
    }
  },
  methods: {
    handleCredentialResponse(response) {
      const token = response.credential;
      const payload = { token };
      document.getElementById('loading-bg-transparent-title').innerText = '👨‍💻 Logging in with Google';
      document.getElementById('loading-bg-transparent').style.display = 'flex';
      this.$store
        .dispatch('auth/v2loginWithGoogle', payload)
        .then((res) => {
          const isTwoFactorAuthEnabled = res.data?.twoFactorAuthentication;
          if (isTwoFactorAuthEnabled) {
            const twoFactorToken = res.data?.token;
            this.$router.push({ name: 'TwoFactor', query: { tempToken: twoFactorToken } });
          } else {
            this.$store.commit('auth/SET_LOGGEDIN', true);
            this.$acl.change('user');

            this.$vs.notify({
              title: 'Login Successful',
              text: 'Redirecting to dashboard!',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success',
            });

            this.$router.push('/dashboard/rooms');
          }
        })
        .catch((error) => {
          const errorResponse = error.response?.data;
          let message = "An error occurred.";
          if (errorResponse?.errors?.email) {
            message = "Account does not exist!";
          } else if (errorResponse?.errors?.password) {
            message = "Incorrect password, Please try again!";
          } else if (typeof errorResponse?.errors === 'string') {
            message = errorResponse.errors;
          }

          this.$vs.notify({
            title: 'Login Failed',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        })
        .finally(() => {
          document.getElementById('loading-bg-transparent').style.display = 'none';
        });
    },
  },
};
</script>

<style scoped>
*:not(i) {
  /* font-family: 'Karla', sans-serif !important; */
  font-family: 'Rethink Sans' !important;
}

.login-m-btn {
  height: 78px;
  width: 80px;
  background-color: #15161F !important;
  border: 1px solid #242632 !important;
  border-radius: 4px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #FFFFFF;
  font-size: 10px;
  padding: 12px 20px;
  pointer-events: auto;
}

.login-m-btn svg {
  height: 30px !important;
  width: 30px !important;
  margin-bottom: 10px;
}

.google-login-wrapper {
  position: relative;
  height: 78px;
  width: 80px;
}

/* Google-rendered button */
#google-btn {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  /* Google button must be clickable */
  opacity: 0;
  /* Hide it visually but allow interaction */
  height: 78px;
  width: 80px;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Your custom button on top */
.custom-overlay-button {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  /* Let click pass through */
}
</style>

<!-- <template>
  <button class="login-m-btn" @click="handleGoogleSignIn">
    <GoogleLogo />
  </button>
</template>

<script>
import constants from '../../../../../constant';
import GoogleLogo from '@/decast/icons/GoogleLogo.vue';

export default {
  name: "GoogleLogin",
  components: {
    GoogleLogo,
  },
  mounted() {
    if (window.google) {
      google.accounts.id.initialize({
        client_id: constants.googleLoginKey,
        callback: this.handleCredentialResponse,
        auto_select: false,
      });
    }
  },
  methods: {
    handleGoogleSignIn() {
      // google.accounts.id.prompt(); // opens popup if auto_select is false
      // This will show the Google popup
      google.accounts.id.prompt((notification) => {
        // Just to satisfy the method, you can handle if needed
      });
    },
    handleCredentialResponse(response) {
      const token = response.credential;
      // const user = jwt_decode(token);
      // You can now send token to your backend for verification
      document.getElementById('loading-bg-transparent-title').innerText = '👨‍💻Logging in with Google';
      document.getElementById('loading-bg-transparent').style.display = 'flex';
      const payload = {
        token: token,
      }
      this.$store
        .dispatch('auth/v2loginWithGoogle', payload)
        .then((response) => {
          const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
          if (isTwoFactorAuthEnabled) {
            //ask for 2fa
            const twoFactorToken = response.data?.token;
            this.$router.push({ name: 'TwoFactor', query: { tempToken: twoFactorToken } });
          } else {
            this.$store.commit('auth/SET_LOGGEDIN', true);
            this.$acl.change('user');
            this.$vs.notify({
              title: 'Login Successful',
              text: 'Redirecting to dashboard!',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success',
            });
            this.$router.push('/dashboard/rooms');
          }
        })
        .catch((error) => {
          console.log(error);
          // Safely extract the specific error message
          const errorResponse = error.response?.data;
          let message = "An error occurred.";
          if (errorResponse?.errors?.email) {
            message = "Account does not exist!";
          } else if (errorResponse?.errors?.password) {
            message = "Incorrect password, Please try again!";
          } else if (typeof errorResponse?.errors === 'string') {
            message = errorResponse.errors;
          }
          this.$vs.notify({
            title: 'Login Failed',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        }).finally(() => {
          document.getElementById('loading-bg-transparent').style.display = 'none';
        });
    },
  },
};
</script>

<style scoped>
.login-m-btn {
  height: 50px !important;
  width: 50px !important;
  background-color: #1B1D29 !important;
  border: 1px solid #242632 !important;
  border-radius: 4px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-m-btn svg {
  height: 18px !important;
  width: 18px !important;
}
</style> -->